export interface EntityInstanceSigners {
  signers: EntityInstanceSigner[];
  allSigned: boolean;
  canSign: boolean;
}

export type EntityInstanceSigner = {
  id: number;
  binding: boolean;
  signed: boolean;
  signId: number;
  userName: string;
  logo?: string;
  isExtraSignature?: boolean;
  userNameInitial?: string;
};
